export const devFeatureFlags = {
  ATS_WORKAROUND: true,
  CANDIDATE_ACCOUNT_UPDATES: true,
  CANDIDATE_DEACTIVATE: true,
  CANDIDATE_MARKETPLACE: true,
  CANDIDATE_RESUME_BUILDER: true,
  CANDIDATE_RESUME_BUILDER_PDF: true,
  CAREER_PATH: true,
  CAREER_QUIZ: true,
  CAREER_QUIZ_RESULTS: true,
  COMPANY_LOCATION: false,
  COMPANY_PARTNERSHIP_LEVELS: true,
  COMPANY_SETTINGS_REDESIGN: true,
  CONTENT_MANAGEMENT: true,
  DIRECT_CONNECT_MANAGEMENT: true,
  EC_CAMPUS_PROGRAM: true,
  EMPLOYER_MARKETING_METRICS: true,
  EXTERNSHIPS: true,
  MULTIPLE_EXTERNSHIPS_PER_COURSE: true,
  PILOT_EXTERNSHIPS: false,
  EXTERNAL_JOB_POSTS: true,
  // Ability for EC Admins/Company Admins to customize GLRC
  GLRC_CUSTOMIZATION: true,
  GOOGLE_SSO: true,
  JOB_RECOMMENDATIONS: true,
  NOTIFICATION_SETTINGS: true,
  PARENT_CHILD_RELATION: true,
  PARENT_DASH: true,
  PARTNER_EXPERIENCE: true,
  PREMIER_PARTNERS_MANAGEMENT: true,
  PREVIOUS_EXPERIENCE: true,
  PROFILE_BADGE: true,
  REPORTING_DASH: true,
  STUDENT_PORTAL_SSO: true,
  WORK_LEARN_CANDIDATE_PAGE: true,
  WORK_AND_LEARN_MANAGEMENT: true,
  ESOURCE_SEARCH: true
};
